import React, { useEffect, useReducer, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import WOW from "wowjs";
function Header() {
  const [sidebar, setSidebar] = useState(false);
  const [isSticky, setSticky] = useState(false);
  const ref = useRef(null);



  /*---------header top Sticky event----------*/
  const handleStickyHeader = () => {
    if (ref.current) {
      setSticky(ref.current.getBoundingClientRect().top <= 0);
    }
  };
 
 
  /*---------menu button event----------*/
  const handleSidbarMenu = () => {
    if (sidebar === false || sidebar === 0) {
      setSidebar(1);
    } else {
      setSidebar(false);
    }
  };

/*---------add event scroll top----------*/
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  /*---------Using reducer mange the active or inactive menu----------*/
  const initialState = { activeMenu: "" };
  const [state, dispatch] = useReducer(reducer, initialState);

  function reducer(state, action) {
    switch (action.type) {
      case "homeTwo":
        return { activeMenu: "homeOne" };
      case "service":
        return { activeMenu: "service" };
      case "project":
        return { activeMenu: "project" };
      case "blog":
        return { activeMenu: "blog" };
      case "page":
        return { activeMenu: "page" };
      default:
        return { activeMenu: "" };
    }
  }

  useEffect(() => {
    new WOW.WOW({
      live: false,
    }).init();
    window.addEventListener("scroll", handleStickyHeader);
    return () => {
      window.removeEventListener("scroll", () => handleStickyHeader);
    };
  }, []);

  return (
    <>
      <header
        className={`${"header-area position_top"} ${isSticky ? "sticky" : ""}`}
        ref={ref}
      >
        <div className="site-logo">
          <div className="logo">
            <Link to={"/"} onClick={scrollTop}>
              <img
                src={process.env.PUBLIC_URL + '/img/logo.png'}
                alt="logo-img"
              />
            </Link>
          </div>
        </div>
        <div className="main-menu">
          <nav className={sidebar === 1 ? "main-nav slidenav" : "main-nav"}>
            <div className="mobile-menu-logo">
              <Link to={"/"} onClick={scrollTop}>
                <img
                  src={process.env.PUBLIC_URL + "img/logo.png"}
                  alt="images"
                />
              </Link>
              <div className="remove" onClick={handleSidbarMenu}>
                <i className="bi bi-plus-lg" />
              </div>
            </div>
            <ul>
              <li
                className=" active"
                onClick={() => dispatch({ type: "homeOne" })}
              >
                <Link
                  to={`/`}
                  className={state.activeMenu === "homeOne" ? "active" : ""}
                >
                  Home
                </Link>
               
              </li>
              <li>
                <NavLink
                  to={`${process.env.PUBLIC_URL}/about`}
                  onClick={scrollTop}
                >
                  About Us
                </NavLink>
              </li>
              <li>
                <Link to={"#"} onClick={() => dispatch({ type: "service" })}>
                  Services
                </Link>
                <i className="bi bi-chevron-down" />
                <ul
                  className={
                    state.activeMenu === "service"
                      ? "sub-menu d-block"
                      : "sub-menu d-none"
                  }
                >
                   <li>
                    <NavLink
                      to={`${process.env.PUBLIC_URL}/ui-ux-design`}
                      onClick={scrollTop}
                    >
                      UI/UX Design
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={`${process.env.PUBLIC_URL}/web-development`}
                      onClick={scrollTop}
                    >
                      Web Development
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={`${process.env.PUBLIC_URL}/ecommerce-solutions`}
                      onClick={scrollTop}
                    >
                      E-Commerce Solutions
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={`${process.env.PUBLIC_URL}/mobile-app-development`}
                      onClick={scrollTop}
                    >
                      Mobile App Development
                    </NavLink>

                  </li>
                  <li>
                    <NavLink
                      to={`${process.env.PUBLIC_URL}/web-application-development`}
                      onClick={scrollTop}
                    >
                      Web Application Development
                    </NavLink>
                    
                  </li>
                  <li>
                    <NavLink
                      to={`${process.env.PUBLIC_URL}/website-maintenance`}
                      onClick={scrollTop}
                    >
                      Website Maintenance
                    </NavLink>
                    
                  </li>
                  <li>
                    <NavLink
                      to={`${process.env.PUBLIC_URL}/digital-marketing`}
                      onClick={scrollTop}
                    >
                      Digital Marketing
                    </NavLink>
                    
                  </li>
                  <li>
                    <NavLink
                      to={`${process.env.PUBLIC_URL}/graphic-design`}
                      onClick={scrollTop}
                    >
                      Graphic Design
                    </NavLink>
                    
                  </li>
               
                  <li>
                    <NavLink
                      to={`${process.env.PUBLIC_URL}/ivr-solutions`}
                      onClick={scrollTop}
                    >
                      IVR Solutions
                    </NavLink>
                    
                  </li>
                 
                </ul>
              </li>
              <li>
                <Link to={`${process.env.PUBLIC_URL}/portfolio`} onClick={scrollTop}>
                  Portfolio
                </Link>
               
              </li>
                <li>
                <NavLink
                  to={`${process.env.PUBLIC_URL}/blog`}
                  onClick={scrollTop}
                >
                 Blog
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={`${process.env.PUBLIC_URL}/contact`}
                  onClick={scrollTop}
                >
                  Contact Us
                </NavLink>
              </li>
            </ul>
            <div className="get-qoute d-flex justify-content-center d-lg-none d-block pt-50">
                    <div className="cmn-btn">
                        <div className="line-1"></div>
                        <div className="line-2"></div>
                         <a href="tel:+919990438600">
               <i class="fas fa-regular fa-headset"></i> +91-99990 438600 (India)
              </a> <br/><br/>
              <a href="tel:+971542170989 ">
               <i class="fas fa-regular fa-headset"></i> +971-542 17 0989 (UAE)
              </a> 
                         
                    </div>   
                </div>
            <div className="get-qoute d-flex justify-content-center d-lg-none d-block pt-50">
                    <div className="cmn-btn">
                        <div className="line-1"></div>
                        <div className="line-2"></div>
                        <Link to={`${process.env.PUBLIC_URL}/contact`} onClick={scrollTop}>Get A Quote</Link>
                         
                    </div>   
                </div>
                
          </nav>
        </div>
        
        <div className="nav-right">
          <div className=" get-qoute calls">
            
              
              <a href="tel:+919990438600">
                <h3><i class="fas fa-regular fa-headset"></i> +91-99904 38600</h3>
              </a>
              
            
          </div>
          <div className="get-qoute">
            <div className="cmn-btn">
              <div className="line-1" />
              <div className="line-2" />
              <Link
                to={`${process.env.PUBLIC_URL}/contact`}
                onClick={scrollTop}
              >
                Let's Connect
              </Link>
            </div>
          </div>
          <div className="mobile-menu">
            <Link to="#" onClick={handleSidbarMenu} className={"cross-btn"}>
              <span className="cross-top" />
              <span className="cross-middle" />
              <span className="cross-bottom" />
            </Link>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
